import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import { CountryPhoneCodeSelect } from 'base/ui/misc';
import { LoadingOverlay } from 'base/ui/status';
import { useRerender } from 'base/utils/common';
import { broadcaster } from 'base/utils/events';


const OtpLoginForm = ({delivery_route_id = null}) => {
    const [form_data, setFormData] = useState({country_phone_code: '254'}) // phone_number, country_phone_code, otp, name
    const [login_data, setLoginData] = useState() // otp_sent, need_name, user
    const [errors, setErrors] = useState(); // invalid_phone_number, otp_error, invalid_otp
    const rerender = useRerender();
    const ctx = useRef({}).current;
    
    const disable_get_otp = !form_data?.country_phone_code || !form_data?.phone_number || errors?.please_enter_phone_number;
    const disable_login = !form_data?.otp || (login_data?.need_name && !form_data?.name) || errors?.otp_error || errors?.invalid_otp;

    const phoneLogin = () => {
        if (login_data?.otp_sent ? !disable_login : !disable_get_otp) {
            if (ctx.is_loading) return;
            ctx.is_loading = true;
            rerender();
            axios.post(`/api/user/login/`, {delivery_route_id, ...form_data}).then((resp) => {
                if (resp.data.errors) {
                    setErrors(resp.data.errors)
                    if(resp.data.errors?.need_name) {
                        setLoginData(resp.data.errors)
                    }
                    return;
                }
                if (resp.data.user) {
                    broadcaster.broadcast_event("_user_", resp.data.user);
                    return;
                }
                setLoginData(resp.data);
            }).finally(() => {
                ctx.is_loading = false;
                rerender();
            })
        }
    }

    const onFormDataChange = (key) => {
        return (evt) => {
            setFormData({...form_data, [key]: evt.target.value});
            setErrors(null)
        }
    }

    useEffect(() => {
        axios.get("/user/location").then(
            (resp) => {
                if (resp.data) {                    
                    setFormData({...form_data, country_phone_code : resp.data.phone_code}); 
                }
            }
        )
    }, [])

    const goBack = () => {
       setLoginData(null);
       setFormData({...form_data, otp: null, name: null});
    }

    return (
        <div>
            {
                ctx.is_loading ? <LoadingOverlay /> : null
            }
            {
                !login_data?.otp_sent
                    ? <form className='tw-mt-8' onSubmit={(evt) => {
                        evt.preventDefault();
                        disable_get_otp ? setErrors({ please_enter_phone_number: true }) : phoneLogin();
                    }}>
                        <div className='tw-text-lg tw-mb-2 font-inter'>Login with your Phone Number</div>
                        <div className='tw-text-xs tw-text-gray-500'>Choose a valid country code and enter mobile number</div>
                        <div className='tw-rounded tw-border tw-flex tw-p-1 tw-w-full tw-mt-6'>
                            <CountryPhoneCodeSelect
                                onChange={(country_phone_code) => {
                                    setFormData({ ...form_data, "country_phone_code": country_phone_code })
                                    setErrors(null)
                                }}
                                default_phone_code={`+${form_data?.country_phone_code}`}
                            />
                            <input type='number' inputMode='numeric' className='tw-flex-1 tw-outline-0 tw-text-md tw-border-l tw-pl-4 tw-appearance-none focus:tw-outline-none focus:tw-ring-0 focus-visible:tw-outline-none focus-visible:tw-ring-0'
                                placeholder='Phone Number'
                                defaultValue={form_data?.phone_number}
                                onChange={onFormDataChange('phone_number')}
                            />
                        </div>
                        {
                            login_data?.need_name
                                ? <div className='tw-rounded tw-border tw-px-4 tw-py-2 tw-w-full tw-mt-6'>
                                    <input type='text' className='tw-outline-0 tw-text-md tw-appearance-none focus:tw-outline-none focus:tw-ring-0 focus-visible:tw-outline-none focus-visible:tw-ring-0'
                                        placeholder='Name'
                                        onChange={onFormDataChange('name')}
                                    />
                                </div>
                                : null
                        }
                        <button
                            type='submit'
                            className="btn-primary-v2 tw-w-full tw-mt-8"
                        >Send OTP</button>
                    </form>
                    : <form onSubmit={(evt) => {
                        evt.preventDefault();
                        disable_login ? setErrors({ invalid_otp: !form_data.otp, invalid_name: !form_data.name }) : phoneLogin();
                    }}>
                        <div className='tw-mb-8 tw-cursor-pointer' onClick={goBack}>
                            <ArrowLeft size={20} className='tw--m-2' />
                        </div>
                        <div className='tw-text-lg tw-mb-2 font-inter'>Verify OTP</div>
                        <div className='tw-text-xs tw-text-gray-500'>Enter the OTP sent on your
                            <span className='tw-font-medium tw-text-gray-600'> WhatsApp No: +{form_data.country_phone_code} {form_data.phone_number}</span>
                        </div>
                        <div className='tw-rounded tw-border tw-px-4 tw-py-2 tw-w-full tw-mt-6'>
                            <input type='number' className='tw-outline-0 tw-text-md tw-w-full tw-appearance-none focus:tw-outline-none focus:tw-ring-0 focus-visible:tw-outline-none focus-visible:tw-ring-0'
                                placeholder='OTP'
                                autoFocus={true}
                                onChange={onFormDataChange('otp')}
                            />
                        </div>
                        <button
                            type='submit'
                            className="tw-tracking-wide btn-primary-v2 tw-w-full tw-mt-8"
                        >
                            SUBMIT
                        </button>

                    </form>
            }
            {
                errors
                    ? <div className='tw-text-center tw-capitalize tw-text-red-600 tw-mt-4'>
                        {Object.entries(errors).map(([key, val]) => (
                            <div key={key}>{val && key.replaceAll('_', ' ')}</div>
                        ))}
                    </div>
                    : null
            }
        </div>
    )
}

export default OtpLoginForm
